module.exports = __webpack_public_path__ + "img/f74d00d.jpg";